<template>
  <div class="container" id="another-block">
    <Header/>
    <transition name="fade-long">
      <div v-if="showFirst" class="another-block__item">
        <p>Socio <i>{{lenderSelected.name}}</i> rechazó tu solicitud</p>
        <img src="https://cdn.crezu.net/game_flow/src/assets/img/sad.svg" alt="">
      </div>
    </transition>
    <transition name="fade-long">
      <div v-if="showSecond" class="another-block__item">
        <p>¡Pero todavía tenemos otras ofertas para ti!</p>
        <img src="https://cdn.crezu.net/game_flow/src/assets/img/party-popper.svg" alt="">
      </div>
    </transition>
    <transition name="fade-long">
      <div v-if="showThird" class="another-block__item">
        <p>¡Elige otra organización de la lista y obtén el préstamo!</p>
        <img src="https://cdn.crezu.net/game_flow/src/assets/img/check_i.png" alt="">
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Header from './Header'

export default {
  name: 'TransitPage',
  components: {Header},
  data: function () {
    return {
      showFirst: false,
      showSecond: false,
      showThird: false,
      lenderName: ''
    }
  },
  computed: {
    ...mapState({
      additionalParams: state => state.additionalParams,
      hardcoreAPILenders: state => state.hardcoreAPILenders
    }),
    lenderSelected: function () {
      return this.hardcoreAPILenders[this.additionalParams.lender_id] || {}
    }
  },
  mounted () {
    this.lenderName = this.lenderSelected.name
    this.$store.commit('CHANGE_ADDITIONAL_PARAMS', { lender_id: undefined })
    setTimeout(() => {
      this.$store.commit('SHOW_TRANSIT_PAGE', false)
    }, 5000)
    setTimeout(() => {
      this.showFirst = true
    }, 1000)
    setTimeout(() => {
      this.showSecond = true
    }, 2000)
    setTimeout(() => {
      this.showThird = true
    }, 3000)
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/transit";
</style>



// WEBPACK FOOTER //
// src/components/TransitPage.vue